import forOwn from 'lodash/forOwn';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { END } from 'redux-saga';
import upperFirst from 'lodash/upperFirst';
import Head from 'next/head';
import React from 'react';
import { connect } from 'react-redux';
import loadjs from 'loadjs';
import nextI18nextConfig from '~/../next-i18next.config';
import { wrapper } from '~/store';
import { locales, slugs } from '~/utils';
import Config, { keyConfig } from '~/config';
import Layout from '~/containers/Layout';
import SearchResultContainer from '~/containers/SearchResultPage';
import {
  initOtherServiceSearchResults,
  searchPhoto,
} from '~/containers/SearchResultPage/actions';
// import { loadPricePremium } from '~/containers/PaymentModal/actions';
import defaultPage, {
  defaultPageServerSideContext,
} from '~/../hocs/defaultPage';
import HrefLangs, {
  generateCanonicalAndLanguageAlternates,
} from '~/components/HrefLangs';
import { loadPinterest } from '~/utils/file-helper';

const mapStateToProps = (state) => ({
  photos: state.searchResult.search.photos,
  location: state.searchResult.search.query,
  total: state.searchResult.search.totalItem,
  totalPage: state.searchResult.search.totalPage,
  token: state.auth.token,
  hasPersonalize: state.searchResult.search.hasPersonalize,
  searchState: state.search,
});

@defaultPage()
@connect(mapStateToProps)
class SearchKeyword extends React.Component {
  static getLinkByServiceType(item, currentLang) {
    const title = slugs.makeSlug(
      item.title[`title_${locales.convertToLongType(currentLang)}`] || '',
      { lang: currentLang },
    );
    return title
      ? `${Config.getSiteURL()}/${keyConfig.get('route_detail_page')}/${
          item.id
        }/${title}`
      : `${Config.getSiteURL()}/${keyConfig.get('route_detail_page')}/${
          item.id
        }`;
  }

  renderAsPath = (query) => {
    query = Object.assign({}, query);
    const url = `/search/${query.keyword}`;
    let params = '';
    let isFirstIndex = true;
    forOwn(query, (query, key) => {
      if (Array.isArray(query)) {
        query = query.map(({ query }) => query).toString();
      }

      //TODO: check google search console for indexing page search
      if (
        query &&
        // key !== 'is_tag' &&
        key !== 'lng' &&
        key !== 'token' &&
        key !== 'clientIp' &&
        key !== 'keyword'
      ) {
        if (isFirstIndex) {
          params = params.concat(`?${key}=${query}`);
          isFirstIndex = false;
        } else {
          params = params.concat(`&${key}=${query}`);
        }
      }
    });

    return url + params;
  };

  componentDidMount() {
    const { query, lng } = this.props;
    loadPinterest();
    const pagePath = this.renderAsPath(query);
    generateCanonicalAndLanguageAlternates(pagePath, lng);
  }

  componentDidUpdate() {
    // window.scrollTo(0, 0);
    const { query, lng } = this.props;
    const pagePath = this.renderAsPath(query);
    generateCanonicalAndLanguageAlternates(pagePath, lng);
  }

  render() {
    const {
      t,
      lng,
      query,
      photos,
      total,
      location,
      totalPage,
      searchState,
    } = this.props;
    const keywords = searchState?.keyword;
    const asPath = `${this.renderAsPath(query)}`;
    let canonical = `${Config.getSiteURL()}${asPath}`;

    if (!location.page) {
      location.page = 1;
    }
    const page = parseInt(location.page, 10);

    const hrefPrev = `${canonical}&page=${parseInt(location.page, 10) - 1}`;
    const hrefNext = `${canonical}&page=${parseInt(location.page, 10) + 1}`;

    const data = photos[0] || {};
    let searchType = 'byText';
    let errorSearchPhoto;
    if (query.is_search_by_photo) {
      searchType = 'byPhoto';
      if (query.error_status || query.error_code || query.error_message) {
        errorSearchPhoto = {
          error_status: query.error_status,
          error_code: query.error_code,
          error_message: query.error_message,
        };
      }
    }

    const titleText =
      page === 1
        ? t(Config.getPrefixContent('title_search_page_seo'), {
            keywords: upperFirst(keywords).replace(/\+/g, ' ') || '',
          })
        : t(Config.getPrefixContent('title_search_page_with_page_seo'), {
            keywords: upperFirst(keywords).replace(/\+/g, ' ') || '',
            page,
          });
    console.log('Data dau tien', data);
    return (
      <Layout>
        <Head>
          {Config.isIllustAC() && (
            <link rel="preload" href={`${data.thumbnail}`} as="image" />
          )}
          <HrefLangs pagePath={this.renderAsPath(query)} lng={lng} />
          {process.browser ? (
            <title>{titleText}</title>
          ) : (
            <title
              dangerouslySetInnerHTML={{
                __html: titleText,
              }}
            />
          )}
          {page === 1 ? '' : <link rel="prev" href={hrefPrev} />}
          {page >= totalPage ? '' : <link rel="next" href={hrefNext} />}
          <meta
            id="meta-keywords"
            name="keywords"
            content={t(
              Config.getPrefixContent('meta_keywords_search_page_seo'),
              {
                keywords: upperFirst(keywords),
              },
            )}
          />
          <meta
            id="meta-description"
            name="description"
            content={t(
              Config.getPrefixContent('meta_description_search_page_seo'),
              {
                keywords,
                total,
              },
            )}
          />
          <meta
            property="og:image"
            content={
              data.thumbnail
                ? data.thumbnail
                : `${
                    Config.staticPrefix
                  }/static/assets/image/logo/${Config.renderImagePage()}`
            }
          />
          <meta
            property="og:title"
            content={t(Config.getPrefixContent('title_search_page_seo'), {
              keywords: upperFirst(keywords || ''),
            })}
          />
          <meta
            property="og:description"
            content={t(
              Config.getPrefixContent('meta_description_search_page_seo'),
              {
                keywords,
                total,
              },
            )}
          />
          {lng === 'en' && <meta property="og:locale" content={'en_US'} />}
          {lng !== 'en' && (
            <meta
              property="og:locale"
              content={lng + '_' + lng?.toUpperCase()}
            />
          )}
          <meta property="og:type" content="article" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:url" content={`${canonical}`} />
          <meta
            name="twitter:title"
            content={t(Config.getPrefixContent('title_search_page_seo'), {
              keywords: upperFirst(keywords).replace(/\+/g, ' ') || '',
            })}
          />
          <meta
            name="twitter:description"
            content={t(
              Config.getPrefixContent('meta_description_search_page_seo'),
              {
                keywords,
                total,
              },
            )}
          />
          <meta name="twitter:image" content={data.path} />
          <meta name="twitter:site" content={`${Config.getSiteURL()}`} />
          <meta name="twitter:creator" content={`@${Config.getName()}`} />
        </Head>
        <SearchResultContainer
          t={t}
          lng={lng}
          searchType={searchType}
          errorSearchPhoto={errorSearchPhoto}
        />
      </Layout>
    );
  }
}

export const getServerSideProps = wrapper.getServerSideProps(
  (store) => async (ctx) => {
    const i18nProps = await serverSideTranslations(
      ctx.locale || process.env.LANGUAGE,
      ['common'],
      nextI18nextConfig,
    );

    const {
      token,
      profile,
      accountType,
      isAuthenticated,
      currentLanguage,
      clientIp,
      api,
      sessionId,
      ssoToken,
      query,
    } = await defaultPageServerSideContext({
      ...ctx,
      store,
    });

    // Custom for page /free-illustrations-vectors, use random string to avoid matching any keywords
    if (query.keyword === 'ZcxyIQHGOUWii4EWMy6nwTEb60fVIbrc8QLBKKQ0k') {
      query.keyword = '';
      query.color = 'all';
      query.modelCount = '-2';
      query.shape = 'all';
      query.orderBy = 'random';
    }

    if (query.keyword === 'undefined') {
      try {
        const dataUrl = new URL(ctx.req.headers.referer);
        const dataQuery = Array.from(dataUrl.searchParams.entries()).reduce(
          (accumulator, [key, value]) => {
            if (key === 'page') {
              accumulator[key] = Number(value);
            } else {
              accumulator[key] = value;
            }
            return accumulator;
          },
          {},
        );
        query.keyword = decodeURIComponent(
          dataUrl.pathname.replace('/search/', ''),
        );

        Object.assign(query, dataQuery);
      } catch (error) {
        console.log(error);
      }
    }

    const searchQuery = {
      ...query,
      language: currentLanguage,
      token: store.getState().auth.token,
      clientIp,
      is_search_personalize:
        Config.isPhotoAC() &&
        store.getState().auth.isAuthenticated &&
        store.getState().searchResult.search.hasPersonalize
          ? '1'
          : '0',
    };

    store.dispatch(searchPhoto(searchQuery, api));
    store.dispatch(initOtherServiceSearchResults());

    // end the saga
    store.dispatch(END);
    await store.sagaTask.toPromise();

    if (store.getState().searchResult?.search?.photos.length === 0) {
      ctx.res.statusCode = 404;
    }

    return {
      props: {
        ...i18nProps,
        token,
        profile,
        accountType,
        isAuthenticated,
        currentLanguage,
        sessionId,
        ssoToken,
        query,
      },
    };
  },
);

export default SearchKeyword;
